import axios from 'axios';

// Anonymous endpoints only. A separate instance keeps the session cookie off these requests and
// bypasses the global interceptors, whose 401 handler redirects to the Snap login.
const publicApi = axios.create({
    baseURL: process.env.REACT_APP_API,
    withCredentials: false
});

export default publicApi;
